import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { userResource } from '@/api/user';
import { customerResource } from '@/views/system/customerManage/request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  data() {
    return {
      dialogVisible: false,
      type: '',
      tagLeftIndex: 0,
      name: '',
      customerName: '',
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '管理员名称'
        },
        dataIndex: 'nickName',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '所属客户'
        },
        dataIndex: 'customerName',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '角色'
        },
        dataIndex: 'roles',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '手机号'
        },
        dataIndex: 'mobile',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '短信通知'
        },
        dataIndex: 'isSms',
        key: '5',
        align: 'center',
        scopedSlots: {
          customRender: 'isSms'
        }
      }, {
        slots: {
          title: ''
        },
        dataIndex: 'checkbox',
        key: '6',
        align: 'center',
        scopedSlots: {
          customRender: 'checkbox'
        },
        width: 80
      }],
      tableData: [],
      originalData: [],
      tagList: [],
      systemList: [],
      systemArr: [],
      customerList: [],
      customerSource: [],
      checkArr: [],
      customerObj: {}
    };
  },
  methods: {
    init(type, list) {
      this.type = type;
      this.tagList = list;
      this.dialogVisible = true;
      this.getDataFun();
      this.getCustomerFun();
    },
    async getCustomerFun() {
      const res = await customerResource({});
      console.log(res);
      this.customerList = res;
      this.customerSource = res;
    },
    tagLeftFun(type) {
      this.tagLeftIndex = type;
      if (type == 0) {
        this.tableData = this.systemList;
        this.customerObj = {};
      }
    },
    async getDataFun() {
      let type = this.tagLeftIndex == 0 ? 0 : 1;
      const res = await userResource({
        customerId: type
      });
      this.tableData = res;
      this.originalData = res;
      this.handleTableFun();
    },
    handleTableFun() {
      let arr = [];
      if (this.tagLeftIndex == 0) {
        arr = this.tagList.filter(item => item.customerId == 0);
      } else {
        arr = this.tagList.filter(item => item.customerId == this.customerObj.id);
      }
      console.log(this.tagList, arr, this.customerObj, '当前数据');
      this.tableData.map(item => {
        const obj = arr.findIndex(value => value.id == item.id || value.userId == item.id);
        console.log(obj);
        if (obj != -1) {
          item.checkbox = 1;
          item.isSms = arr[obj].isSms;
        }
      });
    },
    searchFun() {
      if (this.name) {
        this.name = this.originalData.filter(item => item.nickName.indexOf(this.name) > -1);
      } else {
        this.tableData = this.originalData;
      }
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleSure() {
      this.tagList.map(item => {
        item.userId = item.id || item.userId;
      });
      this.$emit('peopleOk', this.type, this.tagList);
      this.$emit('cancel');
    },
    checkedItem(val) {
      return val == 1 ? true : false;
    },
    checkedFun(val, index) {
      if (!val.checkbox) {
        return this.$message.error(this.$t('请先选中当前人在进行操作'));
      }
      val.isSms = val.isSms ? 0 : 1;
      this.$set(this.tableData, index, val);
      this.tagList.map(item => {
        if (item.id == val.id || item.userId == val.id) {
          item.isSms = val.isSms;
        }
      });
    },
    handleClose(val, valNum) {
      console.log(val);
      let num = -1;
      const valId = val.id || val.userId;
      this.tableData.map((item, index) => {
        let id = item.id || item.userId;
        if (id == valId) {
          num = index;
        }
      });
      if (num != -1) {
        this.tableData[num].checkbox = 0;
        this.tableData[num].isSms = 0;
        this.$set(this.tableData, num, this.tableData[num]);
      }
      const arr = recursionCopy(this.tagList);
      this.tagList = [];
      arr.map(item => {
        let id = item.id || item.userId;
        if (id !== valId) {
          this.tagList.push(item);
        }
      });
    },
    changeCheckbox(val, index) {
      val.checkbox = val.checkbox ? 0 : 1;

      // console.log(this.tableData);
      const valId = val.id || val.userId;
      // const checkArr = this.tableData.filter(item => item.checkbox == 1);
      let arr = [];
      // checkArr.map(item => {
      const obj = this.tagList.findIndex(value => {
        let id = value.id || value.userId;
        console.log(valId == id);
        return valId == id;
      });
      console.log(obj, 111);
      if (obj == -1) {
        console.log(val, obj);
        arr.push(val);
        this.tagList = this.tagList.concat(arr);
      } else {
        this.tagList.splice(obj, 1);
      }
      this.$set(this.tableData, index, val);
      // });

      console.log(this.tagList);
    },
    async customerChange(val) {
      if (this.tagLeftIndex == 0) {
        this.systemList = this.tableData;
        this.systemArr = this.checkArr;
      }
      this.tagLeftIndex = 1;
      this.customerObj = val;
      const res = await userResource({
        customerId: val.id
      });
      this.tableData = res;
      this.originalData = res;
      this.handleTableFun();
    },
    customerNameChange() {
      console.log(this.customerName);
      if (this.customerName) {
        this.customerList = this.customerSource.filter(item => item.name.indexOf(this.customerName) > -1);
      } else {
        this.customerList = this.customerSource;
      }
    }
  }
};